module.exports = __webpack_public_path__ + "img/tg.df126db4.svg";